import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Settings.scss';

export default function Settings() {
  const navigate = useNavigate();

  return (
    <div className="vintage-settings p-4" style={{ backgroundColor: '#fcfaf8', minHeight: '100vh', borderRadius: '12px' }}>
      <h1 className="page-header" style={{ color: '#2c3e50', fontWeight: '700' }}>Einstellungen</h1>

      <Card className="settings-card mb-4 shadow-sm border-0">
        <Card.Body>
          <Card.Title>Dein Profil</Card.Title>
          <Card.Text>
            Verwalte deine persönlichen Daten, ändere dein Passwort und passe dein Profil an.
          </Card.Text>
          <Button variant="outline-primary" onClick={() => navigate('/profile')}>
            Zum Profil wechseln
          </Button>
        </Card.Body>
      </Card>

      <Card className="settings-card shadow-sm border-0">
        <Card.Header className="bg-white border-bottom"><span style={{ fontWeight: '600' }}>Allgemeine Einstellungen</span></Card.Header>
        <Card.Body>
          <p className="text-muted">Hier können zukünftig Einstellungen zur Barrierefreiheit, Benachrichtigungen und weiteren App-Präferenzen vorgenommen werden.</p>
        </Card.Body>
      </Card>
    </div>
  );
}
